"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _util = _interopRequireDefault(require("util"));
var _ampersandState = _interopRequireDefault(require("ampersand-state"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * WebexInternalCore is an extra layer of nesting to make it blatantly clear that
 * private plugins are, in fact, private.
 * @class
 */
var WebexInternalCore = _ampersandState.default.extend({
  derived: {
    ready: {
      deps: [],
      fn: function fn() {
        var _this = this;
        return (0, _keys.default)(this._children).reduce(function (ready, name) {
          return ready && _this[name] && _this[name].ready !== false;
        }, true);
      }
    }
  },
  /**
   * @instance
   * @memberof WebexPlugin
   * @param {number} depth
   * @private
   * @returns {Object}
   */
  inspect: function inspect(depth) {
    return _util.default.inspect(this.serialize({
      props: true,
      session: true,
      derived: true
    }), {
      depth: depth
    });
  }
});
var _default = WebexInternalCore;
exports.default = _default;
//# sourceMappingURL=webex-internal-core.js.map
